import React from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { getLcn } from "~/utils/labeled-classnames";
import { GiDiamondHard } from "react-icons/gi";

export default function RootErrorBoundary() {
  const error = useRouteError();

  if (!error) return null;

  console.log({ error });

  const lcn = getLcn({
    rootErrorBoundary: [
      'flex flex-col items-center justify-center gap-10',
      'p-10 text-center text-2xl min-h-[50vh]'
    ]
  });

  let errorHeader = "Error";
  let errorMessage = "Something went wrong";


  if (isRouteErrorResponse(error)) {
    errorHeader = `${error.status} ${error.statusText}`;
    if (error.status === 404) {
      errorMessage = "The page you're looking for doesn't exist.";
    } else {
      errorMessage = error.statusText || "Something went wrong";
    }
  } else if (error instanceof Error) {
    if (error.message.includes("Failed to fetch dynamically imported module")) {
      errorHeader = "Apllication update detected";
      errorMessage = "Your browser needs to refresh the application in its cache. Please refresh the page.";
    } else {

      errorMessage = error.message;
    }
  }


  return (
    <div className={lcn.rootErrorBoundary}>
      <GiDiamondHard size={100} />
      {errorHeader && <h1 className="text-4xl font-bold">{errorHeader}</h1>}
      <div>{errorMessage}</div>
    </div>
  );
}
